<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.integration.edit.integrations.square.actions.renameDevice.title')"
    :info="$t('components.integration.edit.integrations.square.actions.renameDevice.info')"
    :loading="loading"
    :portal="portal"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', variant: 'success', callback: handleConfirm },
    ]"
  >
    <template #heading>
      <img :src="`${api}/v1/integration/icon?guid=${integration.guid}&type=&size=256`" class="h-10 w-10 rounded-xl mx-auto mt-3">
    </template>

    <div class="text-left mt-6">
      <o-field-group :label="$t('general.name')" :info="$t('components.integration.edit.integrations.square.terminalLabel')" class="mb-4 block">
        <text-field v-model="name" />
      </o-field-group>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import { TextField } from '@/components/fields'
import { OFieldGroup } from '@/components/elements'

const { $api, $config, $notification, $i18n } = useNuxtApp()

interface Props {
  integration: Record<string, any>
  portal?: string
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
})

const emit = defineEmits<{
  (e: 'success'): void
}>()

const dialog = ref<any>()

const loading = ref(false)
const name = ref('')
const device = ref<any>(null)

const api = computed(() => {
  return $config.public.api
})

function open (deviceData: any) {
  device.value = deviceData
  name.value = deviceData.name

  dialog.value.open()
}

async function handleConfirm () {
  loading.value = true

  try {
    const { device_id } = device.value

    const guid = props.integration.objectID?.() ?? props.integration.guid
    const response = await $api.integration.terminal(guid, {
      action: 'rename',
      params: {
        device_id,
        name: name.value,
      },
    })

    $notification.toast({
      title: $i18n.t('general.success'),
      text: $i18n.t('components.integration.edit.integrations.square.actions.renameDevice.successInfo'),
      variant: 'success',
    })

    emit('success')

    return true
  } catch (e: any) {
    $notification.error({ errors: e?.errors })
  }

  loading.value = false
}

defineExpose({ open })
</script>
